import React from 'react';

import classNames from 'classnames';
import DragIcon from 'icons/ic-drag.svg';
import PropTypes from 'prop-types';
import { SortableHandle } from 'react-sortable-hoc';

import RowBar from 'components/application/RowBar';

const DragHandle = SortableHandle((props) => (
  <div
    className={classNames(
      'drag-handle drag-handle--padded',
      props.isOrdering && 'drag-handle--hidden',
    )}
  >
    <DragIcon
      className='drag-icon [&_path]:tw-fill-grey-300'
      height={18}
      width={8}
    />
  </div>
));

export default function ToggleableRow({
  additionalClasses,
  checkboxField,
  isOrdering,
  modifiers,
  toggleableField,
}) {
  return (
    <RowBar
      additionalClasses={classNames(
        'drag-handle-container toggleable-row',
        modifiers?.map((modifier) => `toggleable-row--${modifier}`).join(' '),
        additionalClasses,
      )}
      content={
        <>
          <div className='toggleable-row__dragger'>
            <DragHandle isOrdering={isOrdering} />
          </div>
          <span className='toggleable-row__selector'>{checkboxField}</span>
          <div className='toggleable-row__text-wrapper'>{toggleableField}</div>
        </>
      }
      modifiers={['border-top-none']}
    />
  );
}

ToggleableRow.propTypes = {
  additionalClasses: PropTypes.string,
  checkboxField: PropTypes.node.isRequired,
  isOrdering: PropTypes.bool,
  modifiers: PropTypes.array,
  toggleableField: PropTypes.node.isRequired,
};
